'use client'

import { useTranslations } from 'next-intl'
import { useFeatureValue } from 'growthbook'
import { useCurrentCurrency } from '@repo/cf-user/hooks/use-current-currency'
import { CurrencyCode } from '@web/gen/types'
import { FreeTrialBanner as FreeTrialBannerComponent } from './free-trial-banner'

export function FreeTrialBanner({ isSearchPage = false }: { isSearchPage?: boolean }) {
  const t = useTranslations('components.free_trial_banner')

  if (isSearchPage) {
    return <SearchPageFreeTrialBanner />
  }

  return (
    <FreeTrialBannerComponent
      title={t('title')}
      subTitle={t('sub_title_2')}
      cta={t('cta')}
      cancelText={t('cancel')}
      countdownLabels={{
        tryFreeToday: t('try_free_today'),
        hours: t('hours'),
        mins: t('mins'),
        secs: t('secs'),
      }}
    />
  )
}

function SearchPageFreeTrialBanner() {
  const t = useTranslations('components.free_trial_banner')
  const variant = useFeatureValue('GROW-2230-trial-banner-copy', 0)
  const currency = useCurrentCurrency()
  const zeroPrice = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.code || CurrencyCode.Usd,
    minimumFractionDigits: 0,
  }).format(0)

  const title = variant === 0 ? t('title') : t(`title_${variant}` as const, { zeroPrice })

  return (
    <FreeTrialBannerComponent
      title={title}
      subTitle={t('sub_title_2')}
      cta={t('cta')}
      cancelText={t('cancel')}
      countdownLabels={{
        tryFreeToday: t('try_free_today'),
        hours: t('hours'),
        mins: t('mins'),
        secs: t('secs'),
      }}
    />
  )
}
